export default __webpack_public_path__ + "static/media/resize_icon.f786b013.svg";